import { render, staticRenderFns } from "./DividerWithText.vue?vue&type=template&id=0820872e&scoped=true&"
import script from "./DividerWithText.vue?vue&type=script&lang=js&"
export * from "./DividerWithText.vue?vue&type=script&lang=js&"
import style0 from "./DividerWithText.vue?vue&type=style&index=0&id=0820872e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0820872e",
  null
  
)

export default component.exports